"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initContentDeliveryClient = void 0;
const sdk_1 = require("@prezly/sdk");
const content_delivery_1 = require("../../content-delivery");
const utils_1 = require("../../utils");
const getEnvVariables_1 = require("../lib/getEnvVariables");
function initContentDeliveryClient(req, options) {
    (0, utils_1.assertServerEnv)('initContentDeliveryClient');
    // `getEnvVariables` handles both cases for envs parsing - .env and request headers
    const { PREZLY_ACCESS_TOKEN, PREZLY_NEWSROOM_UUID, PREZLY_THEME_UUID } = (0, getEnvVariables_1.getEnvVariables)(req);
    if (!PREZLY_ACCESS_TOKEN) {
        throw new Error('"PREZLY_ACCESS_TOKEN" is not set in env variables.');
    }
    if (!PREZLY_NEWSROOM_UUID) {
        throw new Error('"PREZLY_NEWSROOM_UUID" is not set in env variables.');
    }
    const prezly = (0, sdk_1.createPrezlyClient)({
        accessToken: PREZLY_ACCESS_TOKEN,
        baseUrl: process.env.API_BASE_URL_OVERRIDE || undefined,
    });
    return content_delivery_1.ContentDelivery.createClient(prezly, PREZLY_NEWSROOM_UUID, PREZLY_THEME_UUID, options);
}
exports.initContentDeliveryClient = initContentDeliveryClient;
//# sourceMappingURL=initContentDeliveryClient.js.map